module.exports = __webpack_public_path__ + "img/search.deb05e8e.svg";